// src/components/profile/ExecutiveOverview/NarrativeDisclosure.jsx
import React, { useState } from 'react';

export default function NarrativeDisclosure({ title, children }) {
  const [open, setOpen] = useState(false);
  
  return (
    <section className="rounded-2xl border bg-white shadow-sm p-6">
      <header className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
        <button 
          onClick={() => setOpen(o => !o)} 
          className="text-xs text-blue-600 hover:text-blue-800 underline"
          aria-expanded={open}
          aria-label={open ? 'Show less content' : 'Read more content'}
        >
          {open ? 'Show less' : 'Read more'}
        </button>
      </header>
      <div className={`overflow-hidden transition-[max-height] duration-150 ease-out ${
        open ? 'max-h-[999px]' : 'max-h-44'
      }`}>
        <div className="space-y-2 text-sm md:text-base text-slate-700 leading-6">
          {children}
        </div>
      </div>
    </section>
  );
}